import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/base'
import './plugins/chartist' 
import vuetify from './plugins/vuetify'
import axios from 'axios' 

axios.defaults.baseURL = 'https://admin.kensrin.co.ke/api_debug'

axios.interceptors.request.use(function (config) {
    var tk =  sessionStorage.getItem('vuex');  
    
    if(tk!=null){  
      // config.headers['Authorization'] = 'Bearer ' + JSON.parse(tk).session.token
    } 
    return config
  }, function (error) {
    return Promise.reject(error)
  })

axios.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger  
    return response
  }, function (error) {
    return Promise.reject(error)
  })

Vue.prototype.$http = axios
Vue.config.productionTip = false 


new Vue({
  store,
  router,
  vuetify,
  render: h => h(App),
}).$mount('#app')

router.beforeEach((to, from, next) => { 
  if (to.path === '/logout') {
    store.dispatch('logout')
    next('/')
  } else {
    if(to.matched.some(record => record.meta.requiresAuth)){
      if (store.getters.isLoggedIn) {
        var c = '/'+ to.path.split('/')[1].toString() +(!to.path.split('/')[2] ? "" : '/'+ to.path.split('/')[2].toString()); 
          
        if(store.state.session){  
            var menuItems = store.state.session.menuItems; 
            var pexists = menuItems.some(menu => menu.to.includes(to.path))
              if (pexists)
                next();
              else
                next('/'); 
        } else 
         next('/')
      } else
         next('/')
    } else 
        next()
  }
})
